import * as Yup from 'yup';
export const initialGenderValues = {
    description: '',
    enumId: '',
};
export const genderSchema = Yup.object().shape({
    description: Yup.string(),
});
//# sourceMappingURL=gender.js.map